import React, { useState } from "react";
import { Heading, Text, Flex, Box } from "@edricphan2022/uikit";
import Container from "../../components/Container";
import HeaderOrbit from "../../components/HeaderOrbit";
import TabActive from "../../components/TabActive";
import ContentHeader from "../../components/ContentHeader";
import FlexLayout from "../../components/LayoutFlex";
import Picture from "../../components/Picture";
import { ArrBlServices } from "./config";
import OurCompetenciess from "./OurCompetencies";
import OurBlockchainTech from "./OurBlockchainTech";

import Rectangle from "../../assets/servicez/gifv1.gif";
import RectangleV2 from "../../assets/servicez/gifv2.gif";
import Panner from "./panner";
import Icon1 from "../../assets/Home/Services/icon1.svg";
import Icon2 from "../../assets/Home/Services/icon2.svg";
import Icon3 from "../../assets/Home/Services/icon3.svg";
import Icon4 from "../../assets/Home/Services/icon5.svg";
import Icon5 from "../../assets/Home/Services/icon6.svg";
import Icon6 from "../../assets/Home/Services/icon7.svg";
// Rectangle.gif

import {
  Wrapper,
  CollapseStyle,
  ServicesTop,
  ServicesDesignAnd,
  // OurProcess,
  BlockchainServices,
  OurCompetencies,
  TextCenter,
  ContentGroup,
  ContentBox,
} from "./styled";

const ArrConten = [
  {
    img: Icon1,
    title: "Mobile Applications and Device Platforms",
    des: "We offer a full-stack Website development, including tailoring a public platform chain with protocols that fit your needs",
  },
  {
    img: Icon2,
    title: "Front-End Development",
    des: "We ensure to thoroughly understand the client's requirements and offer a suitable technical platform.",
  },
  {
    img: Icon3,
    title: "Product testing & reviewing",
    des: "We make a complete delivery of work done based on assignments with testing and reviewing.",
  },
  {
    img: Icon4,
    title: "Back-End Development",
    des: "We guarantee the product for the time specified in the contract to bring the best user experience",
  },
  {
    img: Icon5,
    title: "IOS App Development",
    des: "",
  },
  {
    img: Icon6,
    title: "Android app development",
    des: "",
  },
];

const BlockChainTec = () => {
  const [isBlockChainServices] = useState(ArrBlServices);
  return (
    <Wrapper>
      <CollapseStyle>
        <HeaderOrbit />
        <ServicesTop>
          <Container>
            <TabActive activeIndex={1} />
            <Flex justifyContent="center" pt="40px" pb="70px">
              <Text maxWidth="504px" textAlign="center" fontSize="20px">
                Do your own Mobile App easily with Obit
              </Text>
            </Flex>
          </Container>
        </ServicesTop>
      </CollapseStyle>
      <ServicesDesignAnd>
        <Container position="relative">
          <Panner></Panner>
          <Box pt="48px">
            <h2>Mobile app development</h2>
          </Box>
        </Container>
      </ServicesDesignAnd>
      <TextCenter>
        <h3>
          Aesthetic Design - Meet the user requirements - Security Insurance
        </h3>
      </TextCenter>
      <ContentGroup>
        {ArrConten.map((item, index) => {
          return (
            <ContentBox BgImg = {index === 4 || index === 5}>
              <Box>
                <Box className="IconServices"><img src={item.img} alt="" /></Box>
                <h3>{item.title}</h3>
              </Box>
              <p>{item.des}</p>
            </ContentBox>
          );
        })}
      </ContentGroup>
    </Wrapper>
  );
};

export default BlockChainTec;
